export = {
  techKind: {
    total_points: "Tổng điểm",
    service_points_success: "Ghi điểm khi giao bóng",
    service_points_rate: "Tỷ lệ ghi điểm khi giao bóng",
    receiver_points_success: "Ghi điểm khi nhận bóng",
    receiver_points_rate: "Tỷ lệ ghi điểm khi nhận bóng",
    comeback_to_win: "Lật kèo",
    service_errors: "Lỗi phát bóng",
    biggest_lead: "Cách biệt lớn nhất",
    max_points_in_a_row: "Dành điểm liên tục nhiều nhất",
  },
  percentKeys: ["service_points_rate", "receiver_points_rate"],
  showPreKeys: ["service_points_success", "receiver_points_success"],
};
